import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { ScreenerSettingName } from '@/hooks/screener-settings/screenerSettingName';

import { ProtectedRoute } from '../ProtectedRoute';
import { RoutePath } from '../RoutePath';
import { ScreenerSettingRouteGuard } from '../ScreenerSettingRouteGuard';

const OrgWideSettingsPage = loadable(
  () => import('@/pages/AdminHub/OrgWideSettings/OrgWideSettingsPage')
); // prettier-ignore
const SettingsListPage = loadable(
  () => import('@/pages/AdminHub/OrgWideSettings/SettingsListPage')
); // prettier-ignore
const UserGroupsPage = loadable(
  () => import('@/pages/AdminHub/OrgWideSettings/UserGroupsPage')
); // prettier-ignore
const IPWhitelistPage = loadable(
  () => import('@/pages/AdminHub/OrgWideSettings/IPWhitelistPage')
); // prettier-ignore
const SsoGroupMappingPage = loadable(
  () => import('@/pages/AdminHub/OrgWideSettings/SsoGroupMappingPage')
); // prettier-ignore

export enum AdminHubOrgWideSettingsRoutes {
  AdminHubOrgWideSettings = '/:domain/admin-hub/org-wide-settings',
  AdminHubOrgWideSettingsUserGroups = '/:domain/admin-hub/org-wide-settings/user-groups',
  AdminHubOrgWideSettingsIPWhitelist = '/:domain/admin-hub/org-wide-settings/ip-whitelist',
  AdminHubOrgWideSettingsSsoGroupMapping = '/:domain/admin-hub/org-wide-settings/sso-group-mapping'
}

export const getOrgWideSettingsRoutes = (): RouteObject[] => {
  return [
    {
      path: AdminHubOrgWideSettingsRoutes.AdminHubOrgWideSettings,
      element: <ProtectedRoute component={OrgWideSettingsPage} role="L0" />,
      children: [
        {
          path: AdminHubOrgWideSettingsRoutes.AdminHubOrgWideSettings,
          element: <SettingsListPage />
        },
        {
          path: AdminHubOrgWideSettingsRoutes.AdminHubOrgWideSettingsSsoGroupMapping,
          element: (
            <ScreenerSettingRouteGuard
              settingName={ScreenerSettingName.SsoGroupMappingAdmin}
              requiredValue="enabled"
              redirectTo={RoutePath.AdminHubOrgWideSettings}
            >
              <SsoGroupMappingPage />
            </ScreenerSettingRouteGuard>
          )
        }
      ]
    },
    {
      path: AdminHubOrgWideSettingsRoutes.AdminHubOrgWideSettingsUserGroups,
      element: <ProtectedRoute component={UserGroupsPage} role="L0" />
    },
    {
      path: AdminHubOrgWideSettingsRoutes.AdminHubOrgWideSettingsIPWhitelist,
      element: <ProtectedRoute component={IPWhitelistPage} role="L0" />
    }
  ];
};
